import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For Pages Router, you can use React's `}<a parentName="p" {...{
        "href": "https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary"
      }}>{`Error Boundaries`}</a>{` to catch JavaScript errors anywhere in the component tree.`}</p>
    <p>{`Create a custom error boundary component and report errors to PostHog in the `}<inlineCode parentName="p">{`componentDidCatch`}</inlineCode>{` method:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx",
        "metastring": "file=components/ErrorBoundary.tsx focusOnLines=13-17",
        "file": "components/ErrorBoundary.tsx",
        "focusOnLines": "13-17"
      }}>{`// components/ErrorBoundary.js
import React from 'react'
import posthog from 'posthog-js'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    posthog.captureException(error) // +
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
         {/* ... */}
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
`}</code></pre>
    <p>{`Then wrap your app or specific components with the error boundary:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx",
        "metastring": "file=pages/_app.tsx",
        "file": "pages/_app.tsx"
      }}>{`import type { AppProps } from 'next/app'
import ErrorBoundary from '../components/ErrorBoundary'

export default function App({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary> // +
      <Component {...pageProps} />
    </ErrorBoundary> // +
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      